import React from 'react'

export const OrderSummary = React.lazy(
  () => import(/* webpackChunkName: "order-summary-modal" */ '../modals/order-summary'),
)
